<template>
  <div class="confirmation-status">
    <div v-if="status === 'ISSUED'" class="confirmation-status__issued">
      <div>
        Abbiamo inviato un'email di conferma all'indirizzo
        <span class="semibold">{{ email }}</span>.
        La maggior parte dei biglietti viene emessa e confermata entro 24 ore
        tramite un'email dedicata. A causa delle tempistiche di elaborazione
        delle compagnie aeree, a volte potrebbe essere necessario poco più
        tempo. Non è necessario fare altro, ti invieremo la conferma e i
        dettagli del viaggio non appena l'ordine sarà finalizzato.
        (Ricorda di controllare anche la cartella Spam se non trovi la nostra
        email).
      </div>
    </div>
    <b-alert
      v-else-if="status === 'PENDING'"
      variant="warning"
      show
      class="d-flex"
    >
      <div>
        La prenotazione è definitivamente confermata solo nel momento in cui
        ricevi l'email di conferma che invieremo all'indirizzo
        <span class="semibold">{{ email }}</span>.
        La maggior parte dei biglietti viene emessa e confermata entro 24 ore
        tramite un'email dedicata. A causa delle tempistiche di elaborazione
        delle compagnie aeree, a volte potrebbe essere necessario poco più
        tempo. Non è necessario fare altro, ti invieremo la conferma e i
        dettagli del viaggio non appena l'ordine sarà finalizzato.
        (Ricorda di controllare anche la cartella Spam se non trovi la nostra
        email).
      </div>
    </b-alert>
    <b-alert
      v-else-if="status === 'NOTCONFIRMED'"
      variant="danger"
      show
      class="d-flex"
    >
      <div>
        Ci sono stati alcuni problemi nel confermare la tua prenotazione. Ti
        invitiamo a contattarci appena possibile per ottenere il supporto
        compilando il form nella pagina
        <router-link class="confirmation-status__link" :to="contatti_route">Contattaci</router-link>.
      </div>
    </b-alert>
    <b-alert v-else variant="danger" show class="d-flex">
      <div>
        Lo stato di questa prenotazione richiede una verifica. Ti invitiamo a
        contattarci appena possibile per ottenere il supporto compilando il
        form nella pagina
        <router-link class="confirmation-status__link" :to="contatti_route">Contattaci</router-link>.
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "confirmation-status",

  props: {
    status: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    confirm_code: {
      type: String,
      default: "",
    },
  },

  computed: {
    contatti_route() {
      const query = {};
      if (this.confirm_code) query.confirmcode = this.confirm_code;
      if (this.email) query.email = this.email;
      return { name: "contatti", query };
    },
  },
};
</script>

<style lang="scss">

  .confirmation-status {
    font-size: $font-size-md;

    .alert {
      padding: $grid-gutter-20;
      line-height: normal;
    }

    &__issued {
      margin-bottom: $grid-gutter-20;
      padding: $grid-gutter-20;
      background-color: $white;
      border-radius: $border-radius-lg * 2;
      line-height: normal;
    }

    &__link {
      display: inline;
      text-decoration: underline;
    }
  }
</style>